import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { gridEditable, gridSimple, createGridConfig } from "./gridSettings/gridSettings";


export const PosizioneCausale: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: '$descCausale',
      titleForm: '$descCausale',
      campoTitle: ['descCausale'],
      breadcrumbCaption: 'Gestione posizioni',

      helpDoc: 'Posizione.html',
      service: 'PosizioneCausale',
      api: 'PosizioneCausale',
      filterList: '?idCausale=$idCausale',
      filterEditor: '/$',
      formType: 'simple',
      masterKey: 'id',
      nCol: 2,
      idTabRif: [
        { key: 'idCausale', value: 'idCausale' },
        { key: 'descCausale', value: 'descCausale' },
        {
          key: 'idOperazione',
          value: 'idOperazione'
        },
        {
          key: 'trasporto',
          value: 'trasporto'
        },
        {
          key: 'escludiRegistri',
          value: 'escludiRegistri'
        },
      ],
      /* queryFilter: [

        {
          key: 'descCausale',
          value: 'descrizione'
        },
        {
          key: 'idCausale',
          value: 'id'
        },
        {
          key: 'idCausale',
          value: 'id'
        },
      ] */


    },
  },
  {
    itemType: "group", groupWidth: 838, colCount: '1', colSpan: '2', caption: '', groupDataField: 'dataPosizioneCausale', data: [

      {
        type: 'campoSpecial', dataField: 'posizioneRifiuto_Descrizione', dataType: "", //posizione rifiuto
        hideOnEdit: false,
        caption: "Posizione",
        colVisible: true,
        colWidth: '250',
        nCol: 10,
        disableOnUpdate: true,
        dynamic: {

          dataSource: 'PosizioneRifiuti',
          service: '',
          autocomplete: false,
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Posizioni rifiuto",
          componentType: 'dynamicGrid',
          related: ['id|idPosizioneRifiuto'],
          buttonOption: {
            text: 'PosizioneRifiuto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Posizioni rifiuto',
            name: 'PosizioneRifiuto',
            location: 'after',
          },
          settingGrid: gridEditable
        },
        validation: [
          { type: "required", message: "Posizione obbligatorio" },
        ]

      },
      {

        type: 'campo', dataField: 'disattivaPosizione', dataType: "boolean", caption: 'Disattiva posizione',
        editorType: 'dxCheckBox', trueText: 'Non attiva', falseText: 'Attiva', showEditorAlways: false,
        colWidth: '140px',

      }
    ]
  },
  {
    itemType: "group", colCount: '2', colSpan: '1', caption: 'Produttore', groupDataField: 'datiProduttore', visible: false, data: [


      {
        type: 'campoSpecial', dataField: 'idProduttore', dataType: "",

        caption: "U.L. Produttore",
        class: '',
        maxLength: "40",
        nCol: 10,
        colWidth: '300px',
        hideOnEdit: true,
        colVisible: false,
        lista: {
          dataSource: 'Sede/GetSediNsAziende',
          static: false,
          valueExpr: 'id',
          displayExpr: 'descrizioneSede'
        }

      },
      { type: 'empty' },
      {
        type: 'campoSpecial',
        dataField: 'descrizioneSede_IdProduttore',
        dataType: "",
        caption: "U.L. Produttore",
        class: 'PosizioneCausaleProduttore',
        maxLength: "40",
        nCol: 6,
        colWidth: '300px',
        colVisible: false,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'Sede/GetSediNsAziende',
          service: '',
          valueExpr: '',
          queryString: '?TipoAttivita=P',
          filterStatic: '',
          displayExpr: 'descrizioneSede',
          autocomplete: false,
          searchExpr: 'descrizioneSoggetto',
          caption: "Elenco nostre unità produttive con attività di produzione",
          filter: '',
          related: [
            'id|idProduttore',
            'idSedeRentri|idSedeRentri'
          ],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Unità locali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Unità Locali',
            name: 'ul',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,
            colonne: [
              {
                dataField: 'descrizioneSoggetto',
                dataType: '',
                caption: 'Azienda',
                groupIndex: 0,
                colSpan: '2',
                colWidth: '800',
                hideOnEdit: false
              },
              {
                dataField: 'descrizioneSede',
                dataType: '',
                caption: 'Unità Locale',
                hideOnEdit: false,
                colWidth: '700',
              },
            ]
          })
        },
        validation: [
          { type: "required", message: "Produttore Obbligatorio" },
        ]
      },
      {
        type: 'campo',
        dataField: "idSedeRentri",
        caption: "id R.E.N.T.R.i",
        dataType: "string",
        nCol: 4,
        maxSize: 30,
        showClearButton: false,
        disableOnUpdate: true,
        colVisible: false,
        disabled: true,
      },

      {
        type: 'campoSpecial', dataField: 'idRegistroScarico', dataType: "", //posizione rifiuto
        hideOnEdit: false,
        caption: "Operaz.di scarico su",
        class: 'PosizioneCausaleProduttore hideHelp',
        disabled: true,

        colWidth: '150px',
        colVisible: false,
        maxLength: "40",
        nCol: 10,
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'RegistroRifiuti',
          valueExpr: 'id',
          queryString: '?$filter=(idSede eq $idProduttore)',
          costantValues: [{ key: 'idProduttore', value: 'idProduttore' }],
          displayExpr: 'descrizione',
          static: false,
          showClearButton: true,
          related: ['registroRentri|idRegistroRentriScarico']
        },

        validation: [
          { type: "required", message: "Registro scarico obbligatorio" },
        ],

      },
      { type: 'empty' },
      {
        type: 'campo', dataField: "idRegistroRentriScarico",
        caption: "Op.di scarico R.E.N.T.R.i su",
        dataType: "",
        maxSize: 30,
        showClearButton: false,
        disableOnUpdate: true,
        colVisible: false,

      },
      { type: 'empty' },


    ]
  },
  {
    itemType: "group", groupDataField: 'datiSmaltimento', colCount: '2', colSpan: '1', caption: "Destinatario/Smaltitore", data: [
      /* {
        type: 'empty', dataField: '', caption: 'Dati Smaltimento', labelVisible: false, class: 'datiSmaltimento'
      },
 */
      /* {
        type: 'campoSpecial',
        dataField: 'idDestinatario',
        dataType: "", //posizione rifiuto
        hideOnEdit: false,
        caption: "Destinatario",
        colVisible: false,
        maxLength: "40",
        class:'d-none',
        dynamic: {
          dataSource: 'Sede',
          service: '',
          valueExpr: 'id',
          queryString: '?id=$',
          displayExpr: '',
          autocomplete: false,
          correlateDataField: 'descrizioneDestinatario',

        },


      }, */
      {
        type: 'campoSpecial', dataField: 'idDestinatario', dataType: "",

        caption: "U.L. Destinatario",
        class: '',
        maxLength: "40",
        nCol: 10,
        colWidth: '300px',
        hideOnEdit: true,
        colVisible: false,
        lista: {
          dataSource: 'Sede/GetSediNsAziende',
          static: false,
          valueExpr: 'id',
          displayExpr: 'descrizioneSede'
        }

      },
      { type: 'empty' },
      {
        type: 'campoSpecial', dataField: 'descrizioneSede_IdDestinatario', dataType: "",
        colWidth: '300px',
        caption: "U.L. Destinatario",
        class: 'PosizioneCausaleProduttore',
        maxLength: "40",
        nCol: 6,
        colVisible: false,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'Sede/GetSediNsAziende',
          service: '',
          valueExpr: '',
          queryString: '?TipoAttivita=S',
          displayExpr: 'descrizioneSede',
          autocomplete: false,
          caption: "Elenco nostre unità produttive con attività di smaltimento o deposito",
          filter: '',
          componentType: 'dynamicGrid',
          related: [
            'id|idDestinatario',
            'idSedeRentri|idSedeRentriDestinatario'
          ],
          buttonOption: {
            text: 'Unità locali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Unità Locali',
            name: 'ul',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridSimple,
              colonne: [
                {
                  dataField: 'descrizioneSoggetto',
                  dataType: '',
                  caption: 'Azienda',
                  groupIndex: 0,
                  colSpan: '2',
                  colWidth: '800',
                  hideOnEdit: false
                },

                {
                  dataField: 'descrizioneSede',
                  dataType: '',
                  caption: 'Unità Locale',
                  hideOnEdit: false,
                  colWidth: '700',
                },

              ]
            })


        },
        validation: [
          { type: "required", message: "Destinatario obbligatorio" },
        ]
      },
      {
        type: 'campo',
        dataField: "idSedeRentriDestinatario",
        caption: "id R.E.N.T.R.i",
        dataType: "string",
        nCol: 4,
        maxSize: 30,
        showClearButton: false,
        disableOnUpdate: true,
        colVisible: false,
        disabled: true,
      },

      {
        type: 'campoSpecial',
        dataField: 'idRegistroCarico',
        disabled: true,
        nCol: 10,
        colWidth: '150px',
        colVisible: false,
        hideOnEdit: false,
        caption: "Op.di carico su",
        class: '',
        validation: [
          { type: "required", message: "Registro carico obbligatorio" },
        ],
        maxLength: "40",
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'RegistroRifiuti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          queryString: '?$filter=(idSede eq $idDestinatario)',
          costantValues: [{ key: 'idDestinatario', value: 'idDestinatario' }],
          static: false,
          showClearButton: true,
          related: ['registroRentri|idRegistroRentriCarico']
        },

      },
      { type: 'empty' },
      {
        type: 'campo', dataField: "idRegistroRentriCarico",
        colVisible: false,
        caption: "Op.di carico R.E.N.T.R.i su",
        dataType: "",
        showClearButton: false,
        maxSize: 30,
        disableOnUpdate: true,


      },
      { type: 'empty' },
    ]
  },

  {
    itemType: "group", colCount: '2', colSpan: '1', caption: "Trasportatore", groupDataField: 'datiTrasportatore', data: [

      {
        type: 'campoSpecial', dataField: 'idTrasportatore', dataType: "",

        caption: "U.L. Trasportatore",
        class: '',
        maxLength: "40",
        nCol: 10,
        colWidth: '300px',
        hideOnEdit: true,
        colVisible: false,
        lista: {
          dataSource: 'Sede/GetSediNsAziende',
          static: false,
          valueExpr: 'id',
          displayExpr: 'descrizioneSede'
        }

      },
      { type: 'empty' },
      {
        type: 'campoSpecial', dataField: 'descrizioneSede_IdTrasportatore', dataType: "",
        caption: "U.L. Trasportatore",
        class: '',
        maxLength: "40",
        nCol: 6,
        colVisible: false,
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'Sede/GetSediNsAziende',
          service: '',
          valueExpr: '',
          related: [
            'id|idTrasportatore',
            'idSedeRentri|idSedeRentriTrasportatore'
          ],
          queryString: '?TipoAttivita=T',
          displayExpr: 'descrizioneSede',
          autocomplete: false,
          caption: "Elenco nostre unità produttive con attività di trasporto",
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Unità locali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Unità Locali',
            name: 'ul',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridSimple,
              colonne: [
                {
                  dataField: 'descrizioneSoggetto',
                  dataType: '',
                  caption: 'Azienda',
                  groupIndex: 0,
                  colSpan: '2',
                  colWidth: '800',
                  hideOnEdit: false
                },

                {
                  dataField: 'descrizioneSede',
                  dataType: '',
                  caption: 'Unità Locale',
                  hideOnEdit: false,
                  colWidth: '700',
                },

              ]
            })
        },

      },

      {
        type: 'campo',
        dataField: "idSedeRentriTrasportatore",
        caption: "id R.E.N.T.R.i",
        dataType: "string",
        nCol: 4,
        maxSize: 30,
        showClearButton: false,
        disableOnUpdate: true,
        colVisible: false,
        disabled: true,
      },

      {
        type: 'campoSpecial', dataField: 'idRegistroTrasporto',
        colVisible: false,
        dataType: "", //posizione rifiuto
        hideOnEdit: false,
        caption: "Operaz.di c/s su",
        class: 'PosizioneCausaleidTrasportatore hideHelp',
        disabled: true,
        maxLength: "40",
        nCol: 10,
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'RegistroRifiuti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          queryString: '?$filter=(idSede eq $idTrasportatore)',
          costantValues: [{ key: 'idTrasportatore', value: 'idTrasportatore' }],
          showClearButton: true,
          static: true,
          related: ['registroRentri|idRegistroRentriTrasporto']
        },
        /* validation: [
          { type: "required", message: "Campo Obbligatorio" },
        ]
        */
      },
      { type: 'empty' },
      {
        type: 'campo', dataField: "idRegistroRentriTrasporto",
        caption: "Op.di c/s su R.E.N.T.R.i su",
        dataType: "",
        disableOnUpdate: true,
        maxSize: 30,
        showClearButton: false,
        colVisible: false,

      },
      { type: 'empty' },
    ]
  },
  {
    itemType: "group", groupDataField: 'datiIntermediario', colCount: '2', colSpan: '1', caption: "Intermediario", data: [
      {
        type: 'campoSpecial', dataField: 'idIntermediario', dataType: "",

        caption: "U.L. Intermediario",
        class: '',
        maxLength: "40",
        nCol: 10,
        colWidth: '300px',
        hideOnEdit: true,
        colVisible: false,
        lista: {
          dataSource: 'Sede/GetSediNsAziende',
          static: false,
          valueExpr: 'id',
          displayExpr: 'descrizioneSede'
        }

      },
      { type: 'empty' },
      {
        type: 'campoSpecial', dataField: 'descrizioneSede_IdIntermediario', dataType: "",
        caption: "U.L. Intermediario",
        class: '',
        maxLength: "40",
        nCol: 6,
        colWidth: '300px',
        colVisible: false,
        disableOnUpdate: true,

        dynamic: {
          dataSource: 'Sede/GetSediNsAziende',
          service: '',
          valueExpr: '',
          queryString: '?TipoAttivita=I',
          displayExpr: 'descrizioneSede',
          autocomplete: false,
          caption: "Elenco nostre unità con attività di intermediaizione",
          filter: '',
          componentType: 'dynamicGrid',
          related: ['id|idIntermediario', 'idSedeRentri|idSedeRentriIntermediario'],
          buttonOption: {
            text: 'Unità locali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Unità Locali',
            name: 'ul',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridSimple,
              colonne: [
                {
                  dataField: 'descrizioneSoggetto',
                  dataType: '',
                  caption: 'Azienda',
                  groupIndex: 0,
                  colSpan: '2',
                  colWidth: '800',
                  hideOnEdit: false
                },

                {
                  dataField: 'descrizioneSede',
                  dataType: '',
                  caption: 'Unità Locale',
                  hideOnEdit: false,
                  colWidth: '700',
                },

              ]
            })
        },
        /* validation: [
          { type: "required", message: "Campo Obbligatorio" },
        ] */
      },
      {
        type: 'campo',
        dataField: "idSedeRentriIntermediario",
        caption: "id R.E.N.T.R.i",
        dataType: "string",
        nCol: 4,
        maxSize: 30,
        showClearButton: false,
        disableOnUpdate: true,
        colVisible: false,
        disabled: true,
      },
      {
        type: 'campoSpecial', dataField: 'idRegistroIntermediario', dataType: "", //posizione rifiuto
        hideOnEdit: false,
        caption: "Op.di interm.su",
        colVisible: false,
        class: 'PosizioneCausaleidIntermediario hideHelp',
        disabled: true,
        maxLength: "40",
        nCol: 10,
        editorType: 'dxSelectBox',

        lista: {
          related: ['registroRentri|idRegistroRentriIntermediario'],
          dataSource: 'RegistroRifiuti',
          queryString: '?$filter=(idSede eq $idIntermediario)',
          costantValues: [{ key: 'idIntermediario', value: 'idIntermediario' }],
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,
          showClearButton: true,
        },
        /*   validation: [
            { type: "required", message: "Registro intermediario obbligatorio" },
          ] */
      },
      { type: 'empty' },
      {
        type: 'campo', dataField: "idRegistroRentriIntermediario",
        caption: "Op.di interm.su R.E.N.T.R.i sa",
        dataType: "",
        maxSize: 30,
        colVisible: false,
        showClearButton: false,
        disableOnUpdate: true,
      },
      { type: 'empty' },
    ]
  },
  /*  {
     itemType: "group", groupDataField: 'datiInvisibili', colCount: '1', colSpan: '1', caption: "", data: [
      
       {
         type: 'campo', dataField: 'descrizioneSede_IdProduttore', dataType: "", caption: "U.L. Produttore",
         visible:false,colVisible:false
       },
       {
         type: 'campo', dataField: 'descrizioneSede_IdDestinatario', dataType: "", caption: "U.L. Destinatario",
         visible:false, colVisible:false
       },
       {
         type: 'campo', dataField: 'descrizioneSede_IdTrasportatore', dataType: "", caption: "U.L. Trasportatore",
         visible:false, colVisible:false
       },
      
       {
         type: 'campo', dataField: 'descrizioneSede_IdIntermediario', dataType: "", caption: "U.L. Intermediario",
         visible:false, colVisible:false
       },
      
 
     ]
   }, */


]




